import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=b2887d1c&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=b2887d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2887d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2887d1c')) {
      api.createRecord('b2887d1c', component.options)
    } else {
      api.reload('b2887d1c', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=b2887d1c&scoped=true&", function () {
      api.rerender('b2887d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6wGS5YGi759/JS/comp/DateRange.vue"
export default component.exports